<template>
    <div class="d-inline pr-2 pl-2">
        <b-button class="mb-2 w-100" :variant="variant" @click="analyseHashtags(propHashtags)">
            <i class="fas fa-search"></i>
            Analyse
        </b-button>
    </div>
</template>

<script>
export default {
    name: "buttonScanInBulk",
    props: {
        variant: {
            type: String,
            default: "warning",
        },
        propHashtags: String,
    },
    methods: {
        analyseHashtags(hashtags) {
            this.$router.push({
                name: "bulk",
                params: { propHashtags: hashtags },
            });
        },
    },
};
</script>
